import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  ALBUM_PHOTO_FILTERS,
  ALBUM_PHOTO_FILTERS_LABEL,
} from '../../../../../../../constants/albums';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  albumPhotoFilter: PropTypes.string,
  onAlbumPhotoFilterUpdate: PropTypes.func,
  value: PropTypes.oneOf(Object.values(ALBUM_PHOTO_FILTERS)),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

const PhotoGroupHeaderFilterItem = ({
  value,
  albumPhotoFilter,
  onAlbumPhotoFilterUpdate,
  children,
}) => {
  const classes = classNames('photo-group-header-filter-action-item', {
    selected: albumPhotoFilter === value,
  });

  return (
    <Button
      btnStyle="reset"
      className={classes}
      onClick={() => onAlbumPhotoFilterUpdate({ albumPhotoFilter: value })}
    >
      {ALBUM_PHOTO_FILTERS_LABEL[value]}
      {children}
    </Button>
  );
};

PhotoGroupHeaderFilterItem.propTypes = propTypes;

export default PhotoGroupHeaderFilterItem;
